<template>
  <div>
    <app-form
      ref="app_form_ref"
      :form-data="form_config"
      @confirm="confirm"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { useGetChannelDetails } from '@/views/fusion/investment/intelligence-create/hooks';
export default {
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  mixins: [data_sharing_mixin],
  props: {
    tableRows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // 表单配置
      form_config: {
        channel_code: {
          label: '渠道号',
          type: 'input',
          props: {
            placeholder: '请输入渠道号',
          },
          value: '',
          rules: { required: true, trigger: ['change'], message: '请输入渠道号' },
        },
      },
    };
  },
  computed: {
    /**
     * 渠道配置
     * @returns {Object}
     */
    channel_config() {
      try {
        const form_context = this.local_sharing_data.getFormContext();
        const { channel_config } = form_context.config;
        return channel_config;
      } catch (error){
        console.error(error);
        return {};
      }
    },
  },
  methods: {
    confirm(params) {
      const { channel_code } = params;
      const channels = [channel_code];
      this.$refs['app_form_ref'].isLoading = true;
      useGetChannelDetails(channels).then(res => {
        const { alias } = res[0];
        const { campaign: { campaign_name_separator }} = this.channel_config;
        this.tableRows.forEach(item => {
          const campaign_name = item.campaign.campaign_name;
          const new_campaign_name = campaign_name.split(campaign_name_separator).with(1, alias).join(campaign_name_separator);
          Object.assign(item.campaign, {
            campaign_name: new_campaign_name,
            channel_alias: alias,
          });
        });
        this.$message.success('编辑成功');
        this.$emit('confirm');
      }).finally(() => {
        (this.$refs?.['app_form_ref']?.isLoading && (this.$refs['app_form_ref'].isLoading = false));
      });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
